import React, { useContext } from "react";
import classes from "./Card.module.scss";
import { ModalContext } from "../../store/modal-context";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const Card = ({ boardId, columnId, task }) => {
  const { openModal } = useContext(ModalContext);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: task.id, data: { type: "task", columnId } });

  const completedSubTasksCount =
    task?.subTasks?.filter((st) => st.isCompleted)?.length || 0;
  const totalCount = task?.subTasks?.length || 0;

  const viewTaskHandler = () => {
    openModal("viewTask", { boardId, columnId, taskId: task.id });
  };

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <section
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`${classes.card} ${isDragging ? classes.isDragging : ""}`}
    >
      <h3 className={classes.task} onClick={viewTaskHandler}>
        {task.title}
      </h3>
      <p className={classes.subTask}>
        {completedSubTasksCount} of {totalCount} subtasks
      </p>
    </section>
  );
};

export default Card;
